export const ALERT_MESSAGES = {
  success: {
    type: 'success',
    title: '¡Tu información ha sido recibida con éxito!',
    message:
      'Nuestro equipo la está revisando y pronto nos pondremos en contacto contigo; Gracias por confiar en nosotros.'
  },
  warning: {
    type: 'warning',
    title: 'Información registrada correctamente.',
    message:
      'Hubo un inconveniente al enviar a uno de los servicios, pero tu solicitud fue guardada.'
  },
  error: {
    type: 'error',
    title: 'Error al enviar la información.',
    message: 'Por favor, intenta nuevamente.'
  }
};